const ticket = {
  labels: {
    team: "Support Team",
    new: "New",
    resolved: "Resolved",
    cancelled: "Cancelled",
    waitingOnCustomerFeedback: "Waiting on customer feedback",
    duplicated: "Duplicated",
    inProgress: "In Progress",
    other: "Other",
    createANewTicket: "Create a New Ticket",
    subject: "Subject",
    label: "Label",
    selectLabel: "Please select a label",
    published: "Published On ",
    relatedEquipment: "Related Equipment",
    notAnEquipment: "None",
    description: "Description",
    yourTickets: "Your Tickets",
    issues: "Software Ticket",
    mechanicalSupport: "Hardware Ticket",
    suggestions: "Suggestions",
    ticketProfile: "Ticket Profile",
    status: "Status",
    comments: "Comments",
    comment: "Comment",
    addNewComment: "Add New Comment"
  },
  messages: {
    successful: "The ticket was created successfully",
    commentMinError: "The comment must be at least 5 characters",
    commentNullError: "The comment cannot be empty"
  },
  buttons: {
    backbtn: "Back",
    submit: "Submit",
    confirm: "confirm",
    modulesbtn: "Modules"
  }
};

export default ticket;
